import { type MoneyTransactionSupportRequestReason } from '#app/__generated__/api.js';
import { type ExcludeRelayFutureAddedValue } from '#app/types/utils.js';

export const SUPPORT_REQUEST_REASON_LABELS: Partial<
  Record<
    ExcludeRelayFutureAddedValue<MoneyTransactionSupportRequestReason>,
    string
  >
> = Object.freeze({
  DELAYED_TRANSACTION: 'My payment or payout is taking longer than expected',
  INCORRECT_AMOUNT: 'My payment or payout is not the correct amount',
  INCORRECT_TRANSACTION_STATUS: 'My payment or payout status is not updating',
  MISSING_TRANSACTION: 'My payment or payout is not showing in my bank account',
  OTHER: 'Other',
});

export const DEFAULT_SUPPORT_REQUEST_REASON = 'OTHER' as const;
export const TRANSACTION_LOG_PAGE_SIZE = 6;
